import Statistics from "./icons/Statistics";

interface Props {
  closeModal: boolean;
  setCloseModal: React.Dispatch<React.SetStateAction<boolean>>;
}
const Header = ({ closeModal, setCloseModal }: Props) => {
  return (
    <div className="flex flex-col items-center justify-center mb-6 border-b-2 w-[31rem] md:px-10 sm:w-full sm:mx-2 text-center py-2">
      <h1 className="text-4xl">خمسة بسبعة</h1>
      <div dir="ltr" className="italic text-base mt-2">
        An Arabic word game based on Wordle made by{" "}
        <a
          href="https://www.livingarabic.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <strong>The Living Arabic Project</strong>
        </a>
        . Support on{" "}
        <strong>
          <a
            href="https://www.patreon.com/c/livingarabic"
            target="_blank"
            rel="noopener noreferrer"
          >
            Patreon&nbsp;
          </a>
        </strong>
        for more cool educational games.{" "}
      </div>
    </div>
  );
};

export default Header;

/*Old return
return (
  <div className="flex items-center justify-start mb-6 border-b-2 w-[31rem] md:px-10 sm:w-full sm:mx-2 text-center py-2 ">
    <button className="" onClick={() => setCloseModal(false)}>
      <Statistics />
    </button>
    <h1 className="text-4xl w-full">خمسة بسبعة</h1>
    <div>
      <h2>An Arabic word game based on Wordle</h2>
    </div>
  </div>
);
*/
